export default __webpack_public_path__ + "static/media/users.0d352409.svg";